export default {
  methods: {
    redirectToPayment () {
      this.$store.state.TourList.carts.length && this.$router.push({path: '/payment/'})
    }
  }
}
